import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  updateHeaders(event, options) {
    event.detail[0].setRequestHeader("X-Requested-With", "XMLHttpRequest")
  }
}
